import * as Yup from "yup";

export interface StringFieldOptions {
  label: string;
  required?: boolean;
  regex?: RegExp;
  regexMsg?: string;
  min?: number;
  minMsg?: string;
  max?: number;
  maxMsg?: string;
  length?: number;
  lengthMsg?: string;
}

export function buildStringField(
  options: StringFieldOptions
): Yup.StringSchema<string | undefined> {
  const {
    label,
    required = true,
    regex,
    regexMsg,
    min,
    minMsg,
    max,
    maxMsg,
    length,
    lengthMsg,
  } = options;

  let schema = Yup.string();

  if (required) {
    schema = schema.required(`Required: ${label}`);
  }

  if (regex && regexMsg) {
    schema = schema.matches(regex, regexMsg);
  }

  if (min !== undefined && minMsg) {
    schema = schema.min(min, minMsg);
  }

  if (max !== undefined && maxMsg) {
    schema = schema.max(max, maxMsg);
  }

  if (length !== undefined && lengthMsg) {
    schema = schema.length(length, lengthMsg);
  }

  return schema;
}

export interface NumberFieldOptions {
  label: string;
  required?: boolean;
  min?: number;
  minMsg?: string;
  max?: number;
  maxMsg?: string;
}

export function buildNumberField(
  options: NumberFieldOptions
): Yup.NumberSchema<number | undefined> {
  const { label, required = true, min, minMsg, max, maxMsg } = options;

  let schema = Yup.number();

  if (required) {
    schema = schema.required(`Required: ${label}`);
  }

  if (min !== undefined && minMsg) {
    schema = schema.min(min, minMsg);
  }

  if (max !== undefined && maxMsg) {
    schema = schema.max(max, maxMsg);
  }

  return schema;
}
